<template>
	<div v-loading.fullscreen.lock="loadingSave" :element-loading-text="'Processando...'+(requestParam.uploadProgress != null ? '\n'+requestParam.uploadProgress+'%' : '')">
		<ed-modal 
			:title="this.$store.state.ltcat.title+'Gerar Novo Orçamento'" 
			:modal="showFormEdit" 
			:loadingSave="loadingSave"
			:onSave="salvar"
			width="80%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<ed-form :data="formData" :config="config" :response="response" :itens="exameItems">
					<div slot="form-footer"></div>
				</ed-form>
			</div>
		</ed-modal>
	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdForm from 'common/form';
	import EdModal from 'common/modal';
	import FormItems  from './_form/orcamento-cadastrar';

  	export default {
  		name:"exame-editar",
  		components: {EdForm,EdModal},
		mixins:[Rest],
		props:{
            anexo:{
                type: Object,
                default: function(){
					return {
						id:0,
						descricao:null,
						arquivo:null,
						updated_at:null,
						usuario:null,
						ativo:1
					};
				}
			},
			parent:{
                type: Object,
                default: null
			},
			showForm:{
				type: Boolean,
                default: false
			}
        },
		watch: {
			'$store.state.ltcat.data.id'(){
			},
			'formData.id_tipo_orcamento'(){
				this.config.hidden.id_orc_cp = (this.formData.id_tipo_orcamento != 236);
			},
			showForm(){
				this.showFormEdit = !this.showFormEdit;
				this.init();
			},
		},
  		data () {
		   	return {
				config:{
					tipo:[234],
					click:{
						id_orc_cp:this.getOrcamento
					},
					list:{
						id_orc_cp:[]
					},
					loading:{
						save:false,
						content:false,
						id_orc_cp:false
					},
					hidden:{
						id_orc_cp:true
					}
				},
		   		formData:{
		   			id:0,
		   			id_tipo_orcamento:235,
					descricao:null,
		   			updated_at:null,
					usuario:null,
					id_orc_cp:null
		   		},
				response:{},
				exameItems:[],
				loadingSave:false,
				showFormEdit:false,
			}
		},

		mounted() {
			this.exameItems = FormItems;
		},

		methods: {

			init(){
				this.formData = {
					id:0,
		   			id_tipo_orcamento:235,
					descricao:null,
		   			updated_at:null,
					usuario:null,
					id_orc_cp:null
				};
				this.getOrcamento();
			},

			getOrcamento: function(_search){
				
				this.config.loading.id_orc_cp = true;
				this.config.list.id_orc_cp = [];

				this.get('ltcat/orcamento/'+this.$store.state.ltcat.data.id,{search:_search}).then((result)=>{

		            result = result[0];
					this.config.loading.id_orc_cp = false;

		            if(result.status == 200){
						this.config.list.id_orc_cp = result.data.data;
					}
					
	            });
			},

			salvar(){

				this.response = {};
				this.loadingSave = true;

				this.post('/ltcat/orcamento/'+this.$store.state.ltcat.data.id+'/cadastrar',this.formData).then((result)=>{

					result = result[0];

					this.loadingSave = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Registro salvo com sucesso!');
						this.showFormEdit = !this.showFormEdit;

						if(this.parent.getLtcatOrcamento)
							this.parent.getLtcatOrcamento();
					}

				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// cadastrar.vue?589ac886